/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InterrogatoryZipTaskRequest
 */
export interface InterrogatoryZipTaskRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InterrogatoryZipTaskRequest
     */
    caseFileIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof InterrogatoryZipTaskRequest
     */
    interrogatoryNumber: number;
}

export function InterrogatoryZipTaskRequestFromJSON(json: any): InterrogatoryZipTaskRequest {
    return InterrogatoryZipTaskRequestFromJSONTyped(json, false);
}

export function InterrogatoryZipTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InterrogatoryZipTaskRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'caseFileIds': json['caseFileIds'],
        'interrogatoryNumber': json['interrogatoryNumber'],
    };
}

export function InterrogatoryZipTaskRequestToJSON(value?: InterrogatoryZipTaskRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'caseFileIds': value.caseFileIds,
        'interrogatoryNumber': value.interrogatoryNumber,
    };
}


